<template>
  <el-dialog
    title="添加子账户"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="addChildForm"
      label-width="120px"
    >
      <el-form-item label="父账号公司名称">
        <el-input
          v-model="parentCompanyName"
          disabled
          placeholder="父账号公司名称"
        ></el-input>
      </el-form-item>

      <el-form-item label="手机号" prop="mobile">
        <el-input
          v-model="form.mobile"
          placeholder="请输入手机号"
          maxlength="11"
        ></el-input>
      </el-form-item>

      <el-form-item label="密码" prop="password">
        <el-input
          type="password"
          v-model="form.password"
          placeholder="请输入密码"
          maxlength="16"
          show-password
        ></el-input>
      </el-form-item>

      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input
          type="password"
          v-model="form.confirmPassword"
          placeholder="请再次输入密码"
          maxlength="16"
          show-password
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading"
        >添 加</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { addSubAccount } from '@/api/member'

export default {
  name: 'AddChildUser',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    parentUserData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    // 手机号验证
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确'))
      } else {
        callback()
      }
    }

    // 密码验证
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'))
      } else if (!/^(?=.*?[a-zA-Z])(?=.*?[0-9])[A-Za-z0-9]{6,16}$/.test(value)) {
        callback(new Error('密码必须包含数字和字母，不含特殊字符及空格，6-16位'))
      } else {
        callback()
      }
    }

    // 确认密码验证
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入的密码不一样！'))
      } else {
        callback()
      }
    }

    return {
      dialogVisible: this.visible,
      submitLoading: false,
      form: {
        mobile: '',
        password: '',
        confirmPassword: ''
      },
      rules: {
        mobile: [
          { required: true, validator: validateMobile, trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    parentCompanyName() {
      return this.parentUserData.company_name || ''
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    // 初始化数据
    initData() {
      this.form = {
        mobile: '',
        password: '',
        confirmPassword: ''
      }
      // 清除表单验证
      this.$nextTick(() => {
        if (this.$refs.addChildForm) {
          this.$refs.addChildForm.clearValidate()
        }
      })
    },

    // 关闭对话框
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    // 提交表单
    handleSubmit() {
      this.$refs.addChildForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            const params = {
              parent_id: this.parentUserData.id,
              mobile: this.form.mobile,
              password: this.form.password
            }
            
            const res = await addSubAccount(params)
            
            if (res.err_code === 0) {
              this.$message.success('添加成功')
              this.$emit('success')
              this.handleClose()
            } else if (res.err_code === 2) {
              this.$message.error('参数错误')
            } else if (res.err_code === 1010) {
              this.$message.error('父账户未找到')
            } else if (res.err_code === 1200) {
              this.$message.error('父账户公司未找到(请先完善公司信息)')
            } else {
              this.$message.error(res.err_msg || '未知错误')
            }
          } catch (error) {
            console.error('添加子账户失败:', error)
            this.$message.error('添加失败')
          } finally {
            this.submitLoading = false
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}
</style>